import BymaHome from './Home'

export default BymaHome